module.exports = __webpack_public_path__ + "static/media/preview-twitter-color.b5ac0499.svg";